module.exports = __webpack_public_path__ + "images/trophy-light.svg";